/* eslint-disable one-var */
import { DatePipe } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { TokenService } from 'viggo-sistemas-core-web';
import { AnalyticsService } from '../../global services/analytics-services/analytics.service';

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(
    protected router: Router,
    protected analyticsService: AnalyticsService,
    protected tokenService: TokenService,
    protected datePipe: DatePipe
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isDeleteToken =
      req.url.includes('/tokens') && req.method.includes('DELETE');
    const isPostToken =
      req.url.includes('/tokens') && req.method.includes('POST');

    const acessado_em = this.datePipe.transform(
      this.tokenService.getToken()?.created_at,
      'short'
    );
    const origem = `${isDeleteToken ? 'DESLOGAR DO' : 'LOGAR NO'} SISTEMA - ${
      this.router.url
    }`;
    const rota = `${req.method} - ${req.url}`;

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if (isDeleteToken) {
            this.analyticsService.trackEventUseApi('DESLOGADO_SISTEMA', {
              resposta_api: `${event.status} - ${event.statusText}`,
              conteudo: JSON.stringify(req.body),
              acessado_em,
              origem,
              rota,
              deslogado_em: this.datePipe.transform(new Date(), 'short')
            });
          }

          if (isPostToken) {
            this.analyticsService.trackEventUseApi('ACESSO_SISTEMA', {
              acessado_em,
              origem,
              rota,
              conteudo: JSON.stringify(req.body),
              resposta_api: `${event.status} - ${event.statusText}`,
            });
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (isDeleteToken || isPostToken) {
          this.analyticsService.trackEventUseApi(
            isDeleteToken ? 'DESLOGADO_SISTEMA' : 'ACESSO_SISTEMA',
            {
              resposta_api: JSON.stringify(error.error),
              conteudo: JSON.stringify(req.body),
              acessado_em,
              origem,
              rota,
              deslogado_em: this.datePipe.transform(new Date(), 'short')
            }
          );
        }

        return throwError(() => error);
      })
    );
  }
}
